/**
 * @author Jersson Morales
 * @Copyright (c) Infotrack. All rights reserved.
 */
import React from 'react';
import {
    AppBar,
    Button,
    Card,
    CardContent,
    Checkbox,
    Dialog,
    DialogActions,
    DialogContent,
    FormControlLabel,
    Grid,
    TextField,
    Toolbar,
} from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';

import Texto from '@infotrack/presentacion-componentes/texto';
import { TipoFormulario } from '@infotrack/presentacion-transversales/interfacesComunes';
import { IFormularioBodegasPersonasVistaProps } from '../interfaces';

const FormularioBodegasPersonasVista: React.FunctionComponent<IFormularioBodegasPersonasVistaProps> = ({
    accionCrearEditar,
    cambiarInfoFomulario,
    cerrarFormulario,
    estadoFormulario,
    bodegasPersonas,
    personas,
    tipoFormulario,
}) => (
    <Dialog fullWidth maxWidth="sm" open={estadoFormulario}>
        <AppBar position="static">
            <Toolbar>
                <Grid container justifyContent="center">
                    <Texto
                        align="center"
                        color="inherit"
                        id={
                            tipoFormulario === TipoFormulario.Creacion
                                ? 'bodegasPersonas.agregarBodegasPersonas'
                                : 'bodegasPersonas.modificarBodegasPersonas'
                        }
                    />
                </Grid>
            </Toolbar>
        </AppBar>
        <DialogContent>
            <Card>
                <CardContent>
                    <Grid container spacing={4}>
                        <Grid item xs={12}>
                            <Autocomplete
                                disableClearable
                                disabled={tipoFormulario === TipoFormulario.Edicion ? true : false}
                                getOptionLabel={(persona) => `${persona.PrimerNombre} ${persona.PrimerApellido}`}
                                onChange={(_: any, persona: any) =>
                                    cambiarInfoFomulario({ target: { name: 'Persona', value: persona } } as any)
                                }
                                options={personas}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        fullWidth
                                        label={<Texto id="bodegasPersonas.PersonaId" display="inline" />}
                                    />
                                )}
                                noOptionsText={<Texto id="label.sinRegistros" />}
                                value={
                                    bodegasPersonas.Persona!
                                        ? personas.find(
                                            (persona) => persona.IdPersona === bodegasPersonas.Persona!.IdPersona!
                                        )
                                        : undefined
                                }
                                id={`CampoPersona-${bodegasPersonas.UsuarioId}`}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        color="primary"
                                        checked={Boolean(bodegasPersonas.Estado)}
                                        onChange={cambiarInfoFomulario}
                                    />
                                }
                                label={<Texto id="bodegasPersonas.Estado" display="inline" />}
                                name="Estado"
                                id={`Estado-${bodegasPersonas.Estado}`}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        color="primary"
                                        checked={Boolean(bodegasPersonas.BodegaPrincipal)}
                                        onChange={cambiarInfoFomulario}
                                    />
                                }
                                label={<Texto id="bodegasPersonas.BodegaPrincipal" display="inline" />}
                                name="BodegaPrincipal"
                                id={`BodegaPrincipal-${bodegasPersonas.BodegaPrincipal}`}
                            />
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>
        </DialogContent>
        <DialogActions>
            <div>
                <Grid container justifyContent="flex-end" spacing={2}>
                    <Grid item>
                        <Button onClick={cerrarFormulario} color="secondary" variant="contained" id="boton-cancelar">
                            <Texto id="boton.cancelar" />
                        </Button>
                    </Grid>
                    <Grid item>
                        <Button
                            onClick={accionCrearEditar}
                            color="primary"
                            variant="contained"
                            id={tipoFormulario === TipoFormulario.Creacion ? 'boton-guardar' : 'boton-editar'}
                        >
                            <Texto id={tipoFormulario === TipoFormulario.Creacion ? 'boton.guardar' : 'boton.editar'} />
                        </Button>
                    </Grid>
                </Grid>
            </div>
        </DialogActions>
    </Dialog>
);

export default FormularioBodegasPersonasVista;
